import JSZip from 'jszip';

export type ZipEntry = {
  filename: string;
  blob: Blob;
};

export async function createZipBlob(
  files: ZipEntry[],
  modifiedAt = new Date()
) {
  const zip = new JSZip();

  const fileBuffers = await Promise.all(
    files.map(async (file) => ({
      filename: file.filename,
      data: await file.blob.arrayBuffer(),
    }))
  );

  fileBuffers.forEach((file) => {
    zip.file(file.filename, file.data, { date: modifiedAt });
  });

  return zip.generateAsync({ type: 'blob' });
}
